import { Box } from '@mui/material'

export const AboutPage = () => {
  return (
    <Box>
      This will contain Kiaya's Biography
    </Box>
  )
}